import dayjs from "dayjs";

export function formatAsOfDate(period: string | null): string {
    if (!period) return "N/A";

    if (period.includes("Q")) {
        const quarterMatch = period.match(/(\d{4})-Q(\d)|Q(\d)-(\d{2})/);
        if (quarterMatch) {
            const year = quarterMatch[1] || `20${quarterMatch[4]}`;
            const quarter = parseInt(quarterMatch[2] || quarterMatch[3]);
            const lastMonthOfQuarter = quarter * 3;
            const date = dayjs(
                `${year}-${lastMonthOfQuarter.toString().padStart(2, "0")}-01`,
            );
            return date.format("MMM YYYY");
        }
    }

    if (/^\d{4}$/.test(period)) {
        const date = dayjs(`${period}-12-01`);
        return date.format("MMM YYYY");
    }

    const parsed = dayjs(period);
    if (parsed.isValid()) {
        return parsed.format("MMM YYYY");
    }

    return "N/A";
}
